import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: "conditionalDate",
    standalone: false
})
export class ConditionalDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: any, format: string = "MM/dd/yyyy hh:mm:ss a"): any {
    const isoDateRegex =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;

    if (value instanceof Date || isoDateRegex.test(value)) {
      return this.datePipe.transform(value, format);
    }
    return value;
  }
}
